/**
 * Csv Schema of ResponsavelUsuario
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelUsuario} from '@/model/resource/ResponsavelUsuario'

export class CsvResponsavelUsuarioSchema extends Schema {
  readonly name = 'CsvResponsavelUsuario'

  readonly fieldSet: FieldSet<ResponsavelUsuario> = {
    idResponsavelUsuarioPk: schema => schema.model.idResponsavelUsuarioPk,
    nome: schema => schema.model.nome,
    email: schema => schema.model.email,
    ativo: schema => Helper.bool(schema.model.ativo),
    ehSenhaTemporaria: schema => Helper.bool(schema.model.ehSenhaTemporaria),
    permitirCadastrarUsuario: schema =>
      Helper.bool(schema.model.permitirCadastrarUsuario),
    tipoResponsavelUsuario: schema =>
      schema.model.tipoResponsavelUsuario?.$tag ?? '',
  }
}
